/**
 * @generated SignedSource<<176fae44d5c6d3d4306d6ac12646f318>>
 * @relayHash e356fa116b4c60c1a27e879c4021d428
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/575.0.0-2026-09-01T15:23:14.547Z/NftProfileCollectionQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileCollectionQuery$variables = {
  collectionCursor?: string | null;
  collectionFirst?: number | null;
  creationsCursor?: string | null;
  creationsFirst?: number | null;
  draftsCursor?: string | null;
  draftsFirst?: number | null;
  fetchDrafts: boolean;
  fetchUser: boolean;
  hasTokenContractId: boolean;
  liveAuctionsCursor?: string | null;
  liveAuctionsFirst?: number | null;
  liveBidsCursor?: string | null;
  liveBidsFirst?: number | null;
  lostBidsCursor?: string | null;
  lostBidsFirst?: number | null;
  tokenContractId: string;
  userId: string;
  username: string;
  walletAddress?: string | null;
};
export type NftProfileCollectionQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileCollection_viewer">;
  };
};
export type NftProfileCollectionQuery = {
  response: NftProfileCollectionQuery$data;
  variables: NftProfileCollectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creationsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creationsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchDrafts"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasTokenContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveAuctionsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveAuctionsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveBidsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "liveBidsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lostBidsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lostBidsFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tokenContractId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletAddress"
  }
],
v1 = {
  "items": [
    {
      "kind": "Variable",
      "name": "creatorAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "creatorAddresses"
},
v2 = {
  "items": [
    {
      "kind": "Variable",
      "name": "creatorProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "creatorProfileUsernames"
},
v3 = {
  "kind": "Literal",
  "name": "onlyFirstdibsContracts",
  "value": true
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v5 = [
  (v4/*:: as any*/)
],
v6 = {
  "kind": "Literal",
  "name": "excludeOwnerCreatedItems",
  "value": true
},
v7 = {
  "items": [
    {
      "kind": "Variable",
      "name": "ownerAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "ownerAddresses"
},
v8 = {
  "items": [
    {
      "kind": "Variable",
      "name": "ownerProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "ownerProfileUsernames"
},
v9 = {
  "items": [
    {
      "kind": "Variable",
      "name": "auctionSellerAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "auctionSellerAddresses"
},
v10 = {
  "items": [
    {
      "kind": "Variable",
      "name": "auctionSellerProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "auctionSellerProfileUsernames"
},
v11 = {
  "kind": "Variable",
  "name": "bidderAddress",
  "variableName": "walletAddress"
},
v12 = {
  "kind": "Literal",
  "name": "status",
  "value": "BIDDER_LIVE"
},
v13 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = [
  (v14/*:: as any*/)
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v15/*:: as any*/),
    "storageKey": null
  }
],
v17 = {
  "kind": "Literal",
  "name": "status",
  "value": "BIDDER_LOST"
},
v18 = {
  "kind": "Variable",
  "name": "creatorAddress",
  "variableName": "walletAddress"
},
v19 = [
  (v18/*:: as any*/),
  (v13/*:: as any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importStatus",
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_ERROR"
  ]
},
v23 = {
  "alias": "errored",
  "args": [
    (v22/*:: as any*/)
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v5/*:: as any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
},
v24 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_PROCESSING"
  ]
},
v25 = {
  "alias": "processing",
  "args": [
    (v24/*:: as any*/)
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v5/*:: as any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
},
v26 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_COMPLETE"
  ]
},
v27 = [
  (v26/*:: as any*/)
],
v28 = {
  "alias": "completed",
  "args": (v27/*:: as any*/),
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v5/*:: as any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v32 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "collectionCursor"
  },
  (v6/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "collectionFirst"
  },
  (v7/*:: as any*/),
  (v8/*:: as any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v14/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v31/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NftDigitalArtMetadataMedia",
          "kind": "LinkedField",
          "name": "media",
          "plural": false,
          "selections": [
            (v33/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "posterFrameUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "videoThumb",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "edition",
          "storageKey": null
        }
      ],
      "type": "NftDigitalArtMetadata",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v35 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v37 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "currentBid",
  "plural": false,
  "selections": (v37/*:: as any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "reservePrice",
  "plural": false,
  "selections": (v37/*:: as any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v29/*:: as any*/)
  ],
  "storageKey": null
},
v42 = [
  (v40/*:: as any*/),
  (v41/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ensDomain",
    "storageKey": null
  },
  (v29/*:: as any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "winnerAddress",
  "plural": false,
  "selections": (v42/*:: as any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v45 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherRates",
  "kind": "LinkedField",
  "name": "etherRates",
  "plural": true,
  "selections": (v45/*:: as any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "NftConversionRateEvent",
  "kind": "LinkedField",
  "name": "endedConversionRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": (v45/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = [
  (v40/*:: as any*/),
  (v29/*:: as any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "creatorAddress",
  "plural": false,
  "selections": (v49/*:: as any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "sellerAddress",
  "plural": false,
  "selections": (v49/*:: as any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": (v35/*:: as any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": [
    (v36/*:: as any*/),
    (v38/*:: as any*/),
    (v39/*:: as any*/),
    (v43/*:: as any*/),
    (v44/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v46/*:: as any*/),
        (v29/*:: as any*/),
        (v47/*:: as any*/)
      ],
      "storageKey": null
    },
    (v48/*:: as any*/),
    (v50/*:: as any*/),
    (v51/*:: as any*/),
    (v29/*:: as any*/)
  ],
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wasBurned",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importErrorReason",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "NftItemLikes",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likeCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicProfileUrl",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "creatorAddress",
  "plural": false,
  "selections": [
    (v57/*:: as any*/),
    (v41/*:: as any*/),
    (v29/*:: as any*/),
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSupply",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isERC1155",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "ownerAddress",
  "plural": false,
  "selections": (v42/*:: as any*/),
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenUri",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "NftTokenContract",
  "kind": "LinkedField",
  "name": "contract",
  "plural": false,
  "selections": [
    (v31/*:: as any*/),
    (v29/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "addressWithFields",
      "plural": false,
      "selections": (v49/*:: as any*/),
      "storageKey": null
    },
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v65 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "balanceForUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        },
        (v29/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ownerAddress",
          "plural": false,
          "selections": (v49/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v49/*:: as any*/),
  "storageKey": null
},
v67 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v36/*:: as any*/),
  (v66/*:: as any*/),
  (v29/*:: as any*/)
],
v68 = {
  "alias": "recentAuction",
  "args": (v35/*:: as any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": (v67/*:: as any*/),
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v69 = {
  "alias": "auction",
  "args": (v35/*:: as any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": (v67/*:: as any*/),
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftItemSearchEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*:: as any*/),
          (v34/*:: as any*/),
          (v52/*:: as any*/),
          (v53/*:: as any*/),
          (v54/*:: as any*/),
          (v55/*:: as any*/),
          (v29/*:: as any*/),
          (v56/*:: as any*/),
          (v58/*:: as any*/),
          (v59/*:: as any*/),
          (v60/*:: as any*/),
          (v61/*:: as any*/),
          (v62/*:: as any*/),
          (v63/*:: as any*/),
          (v64/*:: as any*/),
          (v65/*:: as any*/),
          (v68/*:: as any*/),
          (v47/*:: as any*/),
          (v69/*:: as any*/),
          (v14/*:: as any*/)
        ],
        "storageKey": null
      },
      (v70/*:: as any*/)
    ],
    "storageKey": null
  },
  (v71/*:: as any*/)
],
v73 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "liveAuctionsCursor"
  },
  (v9/*:: as any*/),
  (v10/*:: as any*/),
  (v6/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "liveAuctionsFirst"
  }
],
v74 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "creationsCursor"
  },
  (v1/*:: as any*/),
  (v2/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "creationsFirst"
  },
  (v3/*:: as any*/)
],
v75 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "liveBidsCursor"
  },
  (v11/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "liveBidsFirst"
  },
  (v12/*:: as any*/),
  (v13/*:: as any*/)
],
v76 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftAuctionBidderRef",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bidDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EtherAmount",
            "kind": "LinkedField",
            "name": "bidAmount",
            "plural": false,
            "selections": (v37/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "bidderAddress",
            "plural": false,
            "selections": (v49/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftAuction",
            "kind": "LinkedField",
            "name": "auction",
            "plural": false,
            "selections": [
              (v44/*:: as any*/),
              (v29/*:: as any*/),
              (v36/*:: as any*/),
              (v38/*:: as any*/),
              (v39/*:: as any*/),
              (v43/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItem",
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v46/*:: as any*/),
                  (v29/*:: as any*/),
                  (v47/*:: as any*/),
                  (v20/*:: as any*/),
                  (v34/*:: as any*/),
                  (v53/*:: as any*/),
                  (v54/*:: as any*/),
                  (v55/*:: as any*/),
                  (v56/*:: as any*/),
                  (v58/*:: as any*/),
                  (v59/*:: as any*/),
                  (v60/*:: as any*/),
                  (v61/*:: as any*/),
                  (v62/*:: as any*/),
                  (v63/*:: as any*/),
                  (v64/*:: as any*/),
                  (v65/*:: as any*/),
                  (v68/*:: as any*/),
                  (v69/*:: as any*/)
                ],
                "storageKey": null
              },
              (v48/*:: as any*/),
              (v50/*:: as any*/),
              (v51/*:: as any*/)
            ],
            "storageKey": null
          },
          (v29/*:: as any*/),
          (v14/*:: as any*/)
        ],
        "storageKey": null
      },
      (v70/*:: as any*/)
    ],
    "storageKey": null
  },
  (v71/*:: as any*/)
],
v77 = [
  "username",
  "bidderAddress",
  "status"
],
v78 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "lostBidsCursor"
  },
  (v11/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "lostBidsFirst"
  },
  (v17/*:: as any*/),
  (v13/*:: as any*/)
],
v79 = [
  {
    "kind": "Variable",
    "name": "tokenContractId",
    "variableName": "tokenContractId"
  }
],
v80 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "draftsCursor"
  },
  (v18/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "draftsFirst"
  },
  (v13/*:: as any*/)
],
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalUrl",
  "storageKey": null
},
v82 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v83 = [
  (v82/*:: as any*/),
  (v22/*:: as any*/)
],
v84 = [
  (v4/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftTokenContractImportCreatedItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*:: as any*/),
          (v55/*:: as any*/),
          (v34/*:: as any*/),
          (v52/*:: as any*/),
          (v53/*:: as any*/),
          (v54/*:: as any*/),
          (v29/*:: as any*/),
          (v56/*:: as any*/),
          (v58/*:: as any*/),
          (v59/*:: as any*/),
          (v60/*:: as any*/),
          (v61/*:: as any*/),
          (v62/*:: as any*/),
          (v63/*:: as any*/),
          (v64/*:: as any*/),
          (v65/*:: as any*/),
          (v68/*:: as any*/),
          (v47/*:: as any*/),
          (v69/*:: as any*/),
          (v14/*:: as any*/)
        ],
        "storageKey": null
      },
      (v70/*:: as any*/)
    ],
    "storageKey": null
  },
  (v71/*:: as any*/)
],
v85 = [
  "importStatuses"
],
v86 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v87 = [
  (v86/*:: as any*/),
  (v22/*:: as any*/)
],
v88 = [
  (v82/*:: as any*/),
  {
    "kind": "Literal",
    "name": "importStatuses",
    "value": [
      "NFT_ITEM_IMPORT_STATUS_COMPLETE",
      "NFT_ITEM_IMPORT_STATUS_PROCESSING"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileCollectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftProfileCollection_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "NftProfileCollectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "creations",
            "args": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "collection",
            "args": [
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "liveAuctions",
            "args": [
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v5/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "liveBids",
            "args": [
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/)
            ],
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v16/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "lostBids",
            "args": [
              (v11/*:: as any*/),
              (v17/*:: as any*/),
              (v13/*:: as any*/)
            ],
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v16/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "tokenImports",
            "args": (v19/*:: as any*/),
            "concreteType": "NftTokenContractImportsConnection",
            "kind": "LinkedField",
            "name": "nftTokenContractImports",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContractImportsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v23/*:: as any*/),
                      (v25/*:: as any*/),
                      (v28/*:: as any*/),
                      (v29/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "collection",
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*:: as any*/),
                      {
                        "alias": "incompleteItems",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "importStatuses",
                            "value": [
                              "NFT_ITEM_IMPORT_STATUS_ERROR",
                              "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                            ]
                          }
                        ],
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": (v5/*:: as any*/),
                        "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                      },
                      (v21/*:: as any*/),
                      (v23/*:: as any*/),
                      (v25/*:: as any*/),
                      (v28/*:: as any*/),
                      (v30/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftTokenContract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": [
                          (v31/*:: as any*/),
                          (v29/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 4
                          },
                          {
                            "kind": "Literal",
                            "name": "importStatuses",
                            "value": [
                              "NFT_ITEM_IMPORT_STATUS_COMPLETE",
                              "NFT_ITEM_IMPORT_STATUS_PROCESSING",
                              "NFT_ITEM_IMPORT_STATUS_ERROR"
                            ]
                          }
                        ],
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftTokenContractImportCreatedItemsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftItem",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v20/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                      (v14/*:: as any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "NftDigitalArtMetadataMedia",
                                            "kind": "LinkedField",
                                            "name": "media",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "poster",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "posterFrameUrl",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "web",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "webUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "NftDigitalArtMetadata",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v29/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "items(first:4,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\",\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                      },
                      {
                        "alias": "completeItems",
                        "args": (v27/*:: as any*/),
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": (v5/*:: as any*/),
                        "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                      },
                      (v29/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v29/*:: as any*/),
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": null,
            "args": (v32/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v72/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v32/*:: as any*/),
            "filters": [
              "ownerProfileUsernames",
              "ownerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCollection_nftItemSearch",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "nftsForSale",
            "args": (v73/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v72/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "nftsForSale",
            "args": (v73/*:: as any*/),
            "filters": [
              "auctionSellerProfileUsernames",
              "auctionSellerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionAuctions_nftsForSale",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "nftCreations",
            "args": (v74/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v72/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "nftCreations",
            "args": (v74/*:: as any*/),
            "filters": [
              "creatorProfileUsernames",
              "creatorAddresses",
              "onlyFirstdibsContracts"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCreations_nftCreations",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "bidderLiveBids",
            "args": (v75/*:: as any*/),
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v76/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "bidderLiveBids",
            "args": (v75/*:: as any*/),
            "filters": (v77/*:: as any*/),
            "handle": "connection",
            "key": "NftProfileSectionLiveBids_bidderLiveBids",
            "kind": "LinkedHandle",
            "name": "nftAuctionsByBidder"
          },
          {
            "alias": "bidderLostBids",
            "args": (v78/*:: as any*/),
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v76/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "bidderLostBids",
            "args": (v78/*:: as any*/),
            "filters": (v77/*:: as any*/),
            "handle": "connection",
            "key": "NftProfileSectionLostBids_bidderLostBids",
            "kind": "LinkedHandle",
            "name": "nftAuctionsByBidder"
          },
          {
            "alias": null,
            "args": [
              (v13/*:: as any*/)
            ],
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              (v29/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v79/*:: as any*/),
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImportById",
            "plural": false,
            "selections": [
              (v20/*:: as any*/),
              (v29/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "fetchDrafts",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "draftItems",
                "args": (v19/*:: as any*/),
                "concreteType": "NftItemDraftsByCreatorConnection",
                "kind": "LinkedField",
                "name": "nftItemDraftsByCreator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemDraftsByCreatorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v15/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "drafts",
                "args": (v80/*:: as any*/),
                "concreteType": "NftItemDraftsByCreatorConnection",
                "kind": "LinkedField",
                "name": "nftItemDraftsByCreator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemDraftsByCreatorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItemDraft",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*:: as any*/),
                          (v31/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editionNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editionTotal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftMedia",
                            "kind": "LinkedField",
                            "name": "mainMedia",
                            "plural": false,
                            "selections": [
                              (v33/*:: as any*/),
                              (v81/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "videoThumbUrl",
                                "storageKey": null
                              },
                              (v29/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftMedia",
                            "kind": "LinkedField",
                            "name": "posterFrameMedia",
                            "plural": false,
                            "selections": [
                              (v33/*:: as any*/),
                              (v81/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayUrl",
                                "storageKey": null
                              },
                              (v29/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "modifiedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ethereumWalletAddress",
                                "plural": false,
                                "selections": [
                                  (v57/*:: as any*/),
                                  (v29/*:: as any*/),
                                  (v41/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v29/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v29/*:: as any*/),
                          (v14/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v70/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v71/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "drafts",
                "args": (v80/*:: as any*/),
                "filters": [
                  "username",
                  "creatorAddress"
                ],
                "handle": "connection",
                "key": "NftProfileSectionDrafts_drafts",
                "kind": "LinkedHandle",
                "name": "nftItemDraftsByCreator"
              }
            ]
          },
          {
            "condition": "hasTokenContractId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "nftTokenContractImportErrors",
                "args": (v79/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v83/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v84/*:: as any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v83/*:: as any*/),
                    "filters": (v85/*:: as any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v29/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v79/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": "errorItems",
                    "args": (v87/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v88/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v84/*:: as any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": null,
                    "args": (v88/*:: as any*/),
                    "filters": (v85/*:: as any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v21/*:: as any*/),
                  (v66/*:: as any*/),
                  (v30/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContract",
                    "kind": "LinkedField",
                    "name": "contract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenStandard",
                        "storageKey": null
                      },
                      (v29/*:: as any*/),
                      (v31/*:: as any*/),
                      (v40/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "symbol",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "processingItems",
                    "args": [
                      (v86/*:: as any*/),
                      (v24/*:: as any*/)
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": "completeItems",
                    "args": [
                      (v86/*:: as any*/),
                      (v26/*:: as any*/)
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                  },
                  {
                    "alias": "failedItems",
                    "args": (v87/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v5/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": "description",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/575.0.0-2026-09-01T15:23:14.547Z/NftProfileCollectionQuery",
    "metadata": {},
    "name": "NftProfileCollectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da62b1df8b8aaf0308dbd76c9e5f1827";

export default node;
